//import { Z_DEFAULT_COMPRESSION } from "zlib";

// Add excluded disease state id's (as integers) to this array
const excludedStateIds = [];

function isAvailableStateId(stateId) {
    const id = typeof stateId === 'string' ? parseInt(stateId) : stateId;
    return excludedStateIds.indexOf(id) === -1;
}

export default {
    methods: {
        getDiseaseState: function(targetId, key, property) {
            
            let diseaseStates = this.$store.getters.getDiseaseStates; 
            
            /**
             * targetId is likely to be an array
             */

            if(targetId.length == 1) {

                if(isAvailableStateId(targetId[0].target_id)) {
                    let states = diseaseStates.filter(el => el.tid[0].value == targetId[0].target_id);
                    return states.length < 1 ? '' : states[0][key][0][property];
                }
            } else if (targetId.length > 1)
            {
                 
                let states = ''; 
                
                let c = 0; 
                targetId.forEach(function(arr) {

                    if(isAvailableStateId(arr.target_id)) {

                        let filtered = diseaseStates.filter(el => el.tid[0].value == arr.target_id);

                        if (c > 0) {
                            states += '/' + filtered[0][key][0][property];
                        } else {
                            states += filtered[0][key][0][property];
                        }

                        c++;
                    }
                })
                
                return states;
            }

            return ''; 
            
        },
        getTaxonomyData: function(targetId, key, property) {
            
            let productNames = this.$store.getters.getProductNames; 
            let taxonomy = productNames.filter( el => el.nid[0].value == targetId); 
            return taxonomy.length < 1 ? '' : taxonomy[0][key][0][property] ;
        },
        getPhaseData: function(targetId, key, property){
            
            let phases = this.$store.getters.getPhases; 
            let phaseData = phases.filter( el => el.tid[0].value == targetId); 

            return phaseData.length < 1 ? '' : phaseData[0][key][0][property]; 
        },
        setImagePath: function(path){
            
            return path.replace('public/', '');
        },
    }
}